module.exports = __webpack_public_path__ + "img/audi-select-plus.f83e5fed.png";